import React, { useMemo, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { ACCESS_EVENT_TYPES } from '../../services/docuvaultService';

const { FiBell, FiCheck } = FiIcons;

const ALERT_TYPES = ['download', 'delete', 'delegate', 'authorize'];
const WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
const REVIEWED_KEY = 'docuvault_alerts_reviewed_at';

function readReviewedAt() {
  try {
    return Number(localStorage.getItem(REVIEWED_KEY)) || 0;
  } catch {
    return 0;
  }
}

const DocuVaultAccessAlerts = ({ logs }) => {
  const [reviewedAt, setReviewedAt] = useState(readReviewedAt);

  const alerts = useMemo(() => {
    const cutoff = Math.max(Date.now() - WINDOW_MS, reviewedAt);
    return (logs || []).filter(
      l => ALERT_TYPES.includes(l.eventType) && new Date(l.timestamp).getTime() > cutoff
    );
  }, [logs, reviewedAt]);

  const markReviewed = () => {
    const now = Date.now();
    try { localStorage.setItem(REVIEWED_KEY, String(now)); } catch { /* private mode */ }
    setReviewedAt(now);
  };

  const counts = alerts.reduce((acc, l) => {
    acc[l.eventType] = (acc[l.eventType] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="px-5 pt-3">
      <div className="flex items-center justify-between gap-3 p-4 bg-white border border-brand-dark rounded-2xl">
        <div className="flex items-center gap-3 min-w-0">
          <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${alerts.length ? 'bg-red-50' : 'bg-green-50'}`}>
            <SafeIcon icon={alerts.length ? FiBell : FiCheck} className={`w-4 h-4 ${alerts.length ? 'text-red-500' : 'text-green-600'}`} />
          </div>
          <div className="min-w-0">
            <p className="text-[10px] font-black uppercase tracking-widest text-accent-navy">
              {alerts.length
                ? `${alerts.length} sensitive event${alerts.length !== 1 ? 's' : ''} to review`
                : 'No new sensitive events'}
            </p>
            <p className="text-[10px] text-text-muted truncate">
              {alerts.length
                ? ALERT_TYPES.filter(t => counts[t]).map(t => `${counts[t]} ${ACCESS_EVENT_TYPES[t].label.toLowerCase()}`).join(' · ')
                : 'Checks downloads, deletions, delegations and authorizations from the last 7 days in this browser.'}
            </p>
          </div>
        </div>
        {alerts.length > 0 && (
          <button
            onClick={markReviewed}
            className="flex-shrink-0 px-3 py-2 border-2 border-brand-dark rounded-xl text-[9px] font-black uppercase tracking-widest text-text-muted hover:text-accent-navy hover:border-accent-navy transition-all"
          >
            Mark reviewed
          </button>
        )}
      </div>
    </div>
  );
};

export default DocuVaultAccessAlerts;